import { authAPI } from '../api/auth';
import { setUserData } from '../utils/functions';
import { actionWrapper } from './actionWrapper';

export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_PART_USER_DATA = 'SET_PART_USER_DATA';

const loginProceed = (userData) => {
  setUserData(userData);

  return {
    type: SET_USER_DATA,
    payload: userData,
  };
};

const logoutProceed = () => {
  return {
    type: SET_USER_DATA,
    payload: null,
  };
};

export const login = (loginData, { setFieldError }) => actionWrapper(async () => {
  const authData = await authAPI.login(loginData);
  return loginProceed(authData);
}, (errors) => {
  Object.keys(errors).forEach(field => {
    setFieldError(field, errors[field]);
  });
});

export const logout = () => () => {
  localStorage.removeItem('user');
  window.location = '/';
  return logoutProceed();
};